







import { defineComponent } from '@vue/composition-api';
import EmbeddedYoutubeVideo from '@/components/storyblok/EmbeddedYoutubeVideo.vue';
import EmbeddedVimeoVideo from '@/components/storyblok/EmbeddedVimeoVideo.vue';

export default defineComponent({
  name: 'TrackInfoVideo',
  props: { blok: { type: Object } },
  components: { EmbeddedYoutubeVideo, EmbeddedVimeoVideo }
});
